import { all } from "redux-saga/effects";

import { watchDeleteAccount } from "./watchers";

export function* accountSagas() {
  yield all([watchDeleteAccount()]);
}
